import type { DetailRow, PaneData } from '../../shared/contracts';

/**
 * The record rows behind a pane: prefer the drill payload, fall back to the list rows.
 * Single definition shared by the drill modal and the agenda/board cards.
 */
export function detailRowsOf(pane: PaneData): DetailRow[] {
  return pane.details?.length ? pane.details : pane.rows ?? [];
}
